import { observable, action, runInAction } from 'mobx';
import { createViewModel } from 'mobx-utils';
import AgentProfileModel from './agent-profile-model';
import AgentProfileViewModel from './agent-profile-view-model';
import BrokerageProfileModel from './brokerage-profile-model';
import AgentProfileResource from './agent-profile-resource';
import BrokerageProfileResource from './brokerage-profile-resource';
import Notifications from '../utils/notification-helper';

export default class AgentProfileStore {
    @observable selectedAgentProfile = new AgentProfileModel();
    @observable selectedBrokerageProfile = new BrokerageProfileModel();
    @observable selectedAgentBrokerageName = '';
    @observable selectedAgentProfileViewModel;

    constructor(appStore) {
        this.appStore = appStore;
        this.agentProfileResource = new AgentProfileResource();
        this.brokerageProfileResource = new BrokerageProfileResource();
    }

    @action
    loadAgentProfile(agentId, subscriberId, subscriberName) {
        this.selectedAgentProfile = null;
        this.selectedBrokerageProfile = null;

        const agentProfilePromise = this.agentProfileResource.getAgentProfileByAgentId(
            this.appStore.authStore.getAccessToken(),
            agentId
        );
        const brokerageProfilePromise = this.brokerageProfileResource.getBrokerageProfileBySubscriberId(
            this.appStore.authStore.getAccessToken(),
            subscriberId
        );

        Promise.all([agentProfilePromise, brokerageProfilePromise]).then((results) => {
            runInAction(() => {
                const agentProfileModel = results[0];
                const brokerageProfileModel = results[1];

                this.selectedAgentProfile = new AgentProfileModel();
                _.assign(this.selectedAgentProfile, agentProfileModel);

                this.selectedAgentBrokerageName = subscriberName;
                this.selectedBrokerageProfile = new BrokerageProfileModel();
                _.assign(this.selectedBrokerageProfile, brokerageProfileModel);

                const agentProfileViewModel = new AgentProfileViewModel();
                agentProfileViewModel.referralType = this.selectedAgentProfile.referralType;
                agentProfileViewModel.salesRepresentative = this.selectedAgentProfile.salesRepresentative;
                agentProfileViewModel.agentPreferences = this.selectedAgentProfile.preferences;
                agentProfileViewModel.preferredEmail = this.selectedAgentProfile.preferredEmail;
                agentProfileViewModel.brokeragePreferences = this.selectedBrokerageProfile.preferences;

                this.selectedAgentProfileViewModel = createViewModel(agentProfileViewModel);

                if (!this.selectedAgentProfileViewModel.agentContactId) {
                    this.selectedAgentProfileViewModel.agentContactId = agentId;
                }
                if (!this.selectedAgentProfileViewModel.subscriberId) {
                    this.selectedAgentProfileViewModel.subscriberId = subscriberId;
                }
            });
        });
    }

    @action
    updateSelectedAgentProfile(json, redirectToAgentsPage = true) {
        const fieldMap = {
            agent: {
                agentContactId: 'agentContactId',
                referralType: 'referralType',
                salesRepresentative: 'salesRepresentative',
                agentPreferences: 'preferences',
                preferredEmail: 'preferredEmail',
            },
            brokerage: {
                subscriberId: 'subscriberId',
                brokeragePreferences: 'preferences',
            },
        };
        const dirtyProperties = {
            agent: [],
            brokerage: [],
        };

        _.assign(this.selectedAgentProfileViewModel, json);
        _.each(json, (value, key) => {
            if (this.selectedAgentProfileViewModel.isPropertyDirty(key)) {
                if (fieldMap.agent[key]) {
                    const mappedField = fieldMap.agent[key];

                    this.selectedAgentProfile[mappedField] = this.selectedAgentProfileViewModel[key];
                    dirtyProperties.agent.push(mappedField);
                } else if (fieldMap.brokerage[key]) {
                    const mappedField = fieldMap.brokerage[key];

                    this.selectedBrokerageProfile[mappedField] = this.selectedAgentProfileViewModel[key];
                    dirtyProperties.brokerage.push(mappedField);
                }
            }
        });

        //Submit properties to actual model
        this.selectedAgentProfileViewModel.submit();

        const agentResourcePromise = this.agentProfileResource.saveAgentProfile(
            this.appStore.authStore.getAccessToken(),
            this.selectedAgentProfile,
            dirtyProperties.agent
        );
        const brokerageResourcePromise = this.brokerageProfileResource.saveBrokerageProfile(
            this.appStore.authStore.getAccessToken(),
            this.selectedBrokerageProfile,
            dirtyProperties.brokerage
        );

        Promise.all([agentResourcePromise, brokerageResourcePromise])
            .then(() => {
                if (redirectToAgentsPage) this.appStore.viewStore.openAgentsPage();
            })
            .catch((err) => {
                Notifications.ToastError('Error saving agent profile');
                console.log(err);
            });
    }

    @action
    saveAgentProfile(agentProfile, dirtyProperties) {
        return this.agentProfileResource.saveAgentProfile(
            this.appStore.authStore.getAccessToken(),
            agentProfile,
            dirtyProperties
        );
    }

    getAgentProfileByContactId(agentContactId) {
        return this.agentProfileResource.getAgentProfileByAgentId(
            this.appStore.authStore.getAccessToken(),
            agentContactId
        );
    }
}



// WEBPACK FOOTER //
// ./src/agent-profile/agent-profile-store.js